import { FormattedMessage, injectIntl } from "react-intl";
import React, { Component } from "react";
import { compose, graphql } from "react-apollo";

import NotificationProvider from "../../elements/NotificationContent/Notifications";
import ProjectSettingsForm from "./ProjectSettingsForm.jsx";
import Queries from "../../queries/queries2";
import Spinner from "../../elements/Spinner/Spinner.jsx";

class ProjectSettingsEdit extends Component {
  save = async (project, oldProject) => {
    try {
      console.log("ProjectSettingsEdit save", project);
      console.log("oldProject", oldProject);

      if (project.name)
        project.name = project.name.trim();

      await this.props.updateProject({
        variables: project,
        refetchQueries: [
          {
            query: Queries.getCompanyProjectsForProjectSettings,
            variables: {
              companyId: this.props.companyId
            }
          }
        ]
      });
      project["connectClient"] = !!project.tiersClientId;
      project["disconnectClient"] =
        !project.tiersClientId && !!oldProject.tiersClient;
      project["connectCollaborator"] = !!project.tiersCollaboratorId;
      project["disconnectCollaborator"] =
        !project.tiersCollaboratorId && !!oldProject.tiersCollaborator;
      await this.props.connectProject({
        variables: project
      });
      this.sendSuccessUpdateNotification();
    } catch (e) {
      console.info("An error occured:", e);
      this.sendFailureUpdateNotification();
    }
  };

  reaffect = async (values) => {
    try {
      console.log("ProjectSettingsEdit reaffect", values);

      const res = await this.props.reaffectProject({
        variables: values
      });

      this.props.goBack();

      console.log("56 - res=", res);
      if (
        res &&
        res.data &&
        res.data.reaffectProject
        && res.data.reaffectProject.result === true
      ) {

        if (
          res &&
          res.data &&
          res.data.reaffectProject
          && res.data.reaffectProject.warning === true
        )
          this.sendWarningReaffectNotification();
        else
          this.sendSuccessReaffectNotification();

        await this.deleteProjectAndCheck();
      }
      else
        this.sendFailureReaffectNotification();

    } catch (e) {
      console.info("An error occured:", e);
      this.sendFailureUpdateNotification();
    }
  };

  deleteProjectAndCheck = async () => {

    let project =
      this.props.getProject.company &&
      this.props.getProject.company.projects[0];

    console.log("40 - deleteProject=", project);

    if (project) {
      const deleted = await this.props.deleteProject({
        variables: project,
        refetchQueries: [
          {
            query: Queries.getCompanyProjectsForProjectSettings,
            variables: {
              companyId: this.props.companyId
            }
          }
        ]
      });

      return deleted;
    }
    return null;
  };

  sendSuccessUpdateNotification() {
    let notif = NotificationProvider.getSuccessNotification();
    notif.message = (
      <FormattedMessage
        id="ids_projectHasBeenUpdated" />
    );
    this.props.sendNotification(notif);
  }

  sendFailureUpdateNotification() {
    let notif = NotificationProvider.getFailureNotification();
    notif.message = (
      <FormattedMessage
        id="ids_projectSettingsUpdateFailed_notification" />
    );
    this.props.sendNotification(notif);
  }

  sendSuccessReaffectNotification() {
    let notif = NotificationProvider.getSuccessNotification();
    notif.message = (
      <FormattedMessage
        id="ids_projectHasBeenReaffected" />
    );
    this.props.sendNotification(notif);
  }

  sendWarningReaffectNotification() {
    let notif = NotificationProvider.getWarningNotification();
    notif.message = (
      <FormattedMessage
        id="ids_projectHasBeenReaffectedWarning" />
    );
    this.props.sendNotification(notif);
  }

  sendFailureReaffectNotification() {
    let notif = NotificationProvider.getFailureNotification();
    notif.message = (
      <FormattedMessage
        id="ids_projectSettingsReaffectFailed_notification" />
    );
    this.props.sendNotification(notif);
  }

  projectToEdit(project) {
    if (!project) return {};

    console.log("55 - project=", project);
    let isDeletable = true;
    if (
      (project.invoices && project.invoices[0] && project.invoices[0].id) ||
      (project.quotations && project.quotations[0] && project.quotations[0].id) ||
      (project.expenseLines && project.expenseLines[0] && project.expenseLines[0].id) ||
      (project.ecritureLines && project.ecritureLines[0] && project.ecritureLines[0].id) ||
      (project.bankTransactionLines && project.bankTransactionLines[0] && project.bankTransactionLines[0].id) ||
      (project.budgetItems && project.budgetItems[0] && project.budgetItems[0].id) ||
      (project.budgetItemSituations && project.budgetItemSituations[0] && project.budgetItemSituations[0].id)
    ) {
      isDeletable = false;
    }

    let reaffectableToClient = true;
    if (
      (project.invoices && project.invoices[0] && project.invoices[0].id) ||
      (project.quotations && project.quotations[0] && project.quotations[0].id)
    ) {
      reaffectableToClient = false;
    }

    project.budgetItems.forEach(item => {
      if (item.budgetType === "CLIENT")
        reaffectableToClient = false;
    });

    return {
      projectId: project.id || null,
      name: project.name || "",
      active: project.active || false,
      projectType: project.projectType || "",
      dateFinPrevue: project.dateFinPrevue || null,
      tiersClientId: (project.tiersClient && project.tiersClient.id) || null,
      tiersCollaboratorId:
        (project.tiersCollaborator && project.tiersCollaborator.id) || null,
      isDeletable: isDeletable,
      reaffectableToClient: reaffectableToClient
    };
  }

  render() {
    // console.log("ProjectSettingsEdit", this.props);
    if (this.props.getProject.loading) {
      return <Spinner size="lg" fullScreen />;
    } else {
      let project =
        this.props.getProject.company &&
        this.props.getProject.company.projects[0];
      return (
        <ProjectSettingsForm
          {...this.props}
          goBack={() => this.props.goBack()}
          project={this.projectToEdit(project)}
          saveProject={newProject => this.save(newProject, project)}
          reaffectProject={values => this.reaffect(values)}
          handleMinimizeSidebar={this.props.handleMinimizeSidebar}
          deleteProject={this.deleteProjectAndCheck}
        />
      );
    }
  }
}

export default compose(
  graphql(Queries.getProject, { name: "getProject" }),
  graphql(Queries.updateProject, { name: "updateProject" }),
  graphql(Queries.reaffectProject, { name: "reaffectProject" }),
  graphql(Queries.connectProject, { name: "connectProject" }),
  graphql(Queries.deleteProject, { name: "deleteProject" })
)(injectIntl(ProjectSettingsEdit, { withRef: true }));
